import { Head, router } from '@inertiajs/react'
import { RefreshCw } from 'lucide-react'
import CommandCenterLayout from '@/frontend/layouts/CommandCenterLayout'
import CreateLink from '@/frontend/features/ExternalOauth/CreateLink'
import ConnectionCard from '@/frontend/features/ExternalOauth/ConnectionCard'
import { label, secondaryClass, type Props } from '@/frontend/features/ExternalOauth/types'

function Index({ page_title, copy, connections, pagination, ...targets }: Props) {
  return <>
    <Head title={page_title} />
    <div className="mx-auto w-full max-w-5xl space-y-6">
      <header className="flex items-start justify-between gap-5">
        <div><h1 className="text-2xl font-semibold tracking-tight">{page_title}</h1>
          <p className="mt-2 max-w-2xl text-sm text-muted-foreground">{label(copy, 'description')}</p></div>
        <button className={`${secondaryClass} inline-flex items-center gap-2`} onClick={() => router.reload()}><RefreshCw size={14} />{label(copy, 'reload')}</button>
      </header>
      <CreateLink copy={copy} toolkits={targets.toolkits} validity_options={targets.validity_options} />
      {connections.length === 0 && <p className="rounded-xl border border-dashed border-border p-10 text-center text-sm text-muted-foreground">{label(copy, 'empty')}</p>}
      {connections.map((connection) => <ConnectionCard key={connection.id} connection={connection} copy={copy} {...targets} />)}
      {pagination.pages > 1 && <nav className="flex items-center justify-between">
        <button disabled={pagination.page <= 1} className={secondaryClass} onClick={() => router.get('/cc/external_oauth_connections', { page: pagination.page - 1 })}>{label(copy, 'previous')}</button>
        <span className="text-sm text-muted-foreground">{pagination.page} / {pagination.pages}</span>
        <button disabled={pagination.page >= pagination.pages} className={secondaryClass} onClick={() => router.get('/cc/external_oauth_connections', { page: pagination.page + 1 })}>{label(copy, 'next')}</button>
      </nav>}
    </div>
  </>
}
Index.layout = (page: React.ReactElement) => <CommandCenterLayout>{page}</CommandCenterLayout>
export default Index
